

class Campaign {
    constructor(params) {
    
    this.generic = {};
  this.setParameters(params);
  this.isParent = false;
  this.generic.model = "campaign";
  this.generic.platformId = this.platformId;
    }
  
    setParameters(params){
      for (var prop in params){
          if (params.hasOwnProperty(prop)){
              var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
              if (this[method]){
                  this[method](params[prop]);
              }else{
                this[prop] = params[prop];
              }
              
          }
      }
    }
    setId(val){
      this.platformId = val;
      this.generic.id = val;
    }
      
    setName(val){
      this.name = val;
      this.generic.name = val;
    }
    setPlatformId(val){
      this.platformId = val;
      this.generic.platformId = val;
      this.generic.id = val;
      this.generic.subTitle = val;
    }
    setManager(val){
      this.loginCustomerId = val;
    }
}

export default Campaign;
   